import { ThemeUICSSObject } from '@apia/theme';
import { permissions } from './permissions';
/* IMPORT HERE */
export const collapsiblePanel: ThemeUICSSObject = {
  '.collapsiblePanel': {
    display: 'flex',
    flexDirection: 'column',
  },

  '.collapsiblePanel__label': {
    '& span': {
      fontWeight: 700,
    },

    '& button > span': {
      fontWeight: 'normal',
    },
  },

  '.collapsiblePanel__label__button': {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    justifyContent: 'space-between',
    '&[aria-expanded="false"]': {
      borderBottom: '1px solid #e1e1e1',
    },
  },
  '.collapsiblePanel__content': {
    '&>div': {
      display: 'flex',
      flexDirection: 'column',
      gap: 3,
      border: '1px solid',
      borderColor: 'palette.border.field',
      padding: 4,
      borderRadius: 'default',
      background: 'inherit',
      boxShadow: 'neum',
    },
  },
};

export const defaultView: ThemeUICSSObject = {
  '&.uploader__container': {
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
    overflow: 'auto',
    'button[data-variant="outline"]': {
      boxShadow: 'sharp',
    },
  },
  '.uploader__content': {
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
    overflow: 'auto',
    p: 2,
    overflowX: 'hidden',
  },
  '& label': {
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
    span: {
      fontWeight: 700,
    },
  },
  '.uploader__file_selection': {
    display: 'flex',
    flexDirection: 'row',
    gap: 3,
    alignItems: 'center',
    alignContent: 'center',
    width: '100%',
    '.autocomplete': {
      width: '100%',
    },
    '.uploader__file_infoBtn': {
      height: '48px',
      width: '48px',
      p: 0,
      display: 'flex',
    },
  },
  '.uploader__dropzone_description_section': {
    display: 'flex',
    flexDirection: 'column',
    gap: 3,
    background: 'inherit',
    padding: 4,
    borderRadius: 'default',
    border: '1px solid',
    borderColor: 'palette.border.field',
    boxShadow: 'neum',
  },
  '.uploader__dropzone': {
    display: 'grid',
    flexDirection: 'column',
    gap: 3,
    width: ' 100%',
    position: 'relative',
    '.dropzone__container[class]': {
      height: '100%',
    },
    '.dropzone': {
      height: '50px',
    },
    '.uploader__dropzone_actions': {
      display: 'flex',
      flexDirection: 'row',
      gap: 3,
      button: {
        width: '50%',
      },
    },
  },
  '.uploader__directory': {
    '.collapsiblePanel__content': {
      '&>div': {
        position: 'relative',
      },
      '.uploader__directory__clear-directory': {
        position: 'sticky',
        top: 0,
        alignSelf: 'end',
        width: '20px',
        height: '20px',
        p: 3,
      },
    },
  },

  ...collapsiblePanel,
  ...permissions,

  '.mobxtree': {
    background: 'white',
    border: '1px solid',
    borderColor: 'palette.border.field',
    borderRadius: 'default',
    padding: '5px',
  },

  '.metadata__container': {
    outline: 'none!important',
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    background: 'palette.background.paper',
    padding: 3,
    borderRadius: 'default',
    border: '1px solid',
    borderColor: 'palette.border.field',

    '.metadata__table_container': {
      width: '100%',
      maxHeight: '310px',
      overflowY: 'auto',
      display: 'block',
      boxSizing: 'border-box',
      position: 'relative',
      table: {
        width: '100%',
        borderCollapse: 'collapse',
        tableLayout: 'fixed',
        boxSizing: 'border-box',
        td: { borderLeft: 0, borderRight: 0 },

        'tr:last-child td:first-child': {
          borderBottomLeftRadius: 'default',
        },
        'tr:last-child td:last-child': {
          borderBottomRightRadius: 'default',
        },
      },

      th: {
        position: 'sticky',
        top: 0,
        backgroundColor: 'palette.background.paper',
        zIndex: 2,
        border: 'none',
        borderBottom: '1px solid #ccc',
        padding: '8px',
        textAlign: 'left',
      },
      tbody: {
        '.selected': {
          background: 'palette.gray.900',
        },
        td: {
          padding: 3,
          borderBottom: '1px solid #ececec',
          verticalAlign: 'top',
        },
        '.iconButton': {
          border: 'none',
        },
      },
      '.metadata__render_container': {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: 1,
        position: 'relative',
        minHeight: '50px',
        '.metadata__field_line': {
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'flex-start',
          gap: 1,
          width: '100%',
        },
        '.requiredMark': {
          color: 'danger',
          position: 'static',
          flex: '0 0 auto',
        },
        '.errorRequired': {
          color: 'danger',
          display: 'block',
        },
        '&.metadata__render_container--required-before .errorRequired': {
          marginLeft: 'calc(1em + 4px)',
        },
      },
    },

    '.metadata__actions': {
      display: 'flex',
      flexDirection: 'row',
      gap: 3,
    },

    '.addMetadata, .deleteMetadata': {
      height: '30px',
      width: '30px',
      p: '0px',
    },
  },
};
